module.exports = __webpack_public_path__ + "80f08dbd899784f047d8481c26fed6e8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-17.png
// module id = 2560
// module chunks = 0